import { VITE_BASE_API_URL, VITE_CLOUDWATCH_URL } from "@/constants/config";

import { BaseQueryFn, FetchArgs } from "@reduxjs/toolkit/query";
import {
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "./prepareHeaders";

export const rawBaseQuery = fetchBaseQuery({
  baseUrl: VITE_BASE_API_URL,
  prepareHeaders,
});

export const logHeader = (response: Response | undefined, method?: string) => {
  if (!response) return;
  const { headers, url, status } = response;
  const xray = headers.get("x-amzn-trace-id");
  if (xray) {
    const trace = (xray.match(/Root=([^;]+)/) || [])[1];
    console.warn(
      `%cBackend call (${new Date().toISOString()}) \n %c${new URL(url).pathname} %c(${method} ${status}) \n %c${VITE_CLOUDWATCH_URL}${trace}`,
      "font-weight: bold;",
      "color: #2196f3;",
      status === 200 ? "color: green;" : "color: yellow;",
      "color: white;"
    );
  }
};

export const customBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  any,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  logHeader(result.meta?.response, result.meta?.request.method);
  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
  tagTypes: [
    "Errors",
    "Record",
    "Records",
    "Activities",
    "Tasks",
    "Schema",
    "File",
    "Users",
  ],
});
